module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "c-menu-mobile u-bg--black u-pad-y-1"
  }, [_c('button', {
    staticClass: "t-btn u-w1of4 u-align-center u-marg-t-lg u-marg-b-xxl u-marg-b-lg@md",
    on: {
      "click": _vm._close
    }
  }, [_c('img', {
    staticClass: "u-marg-t-xxs",
    attrs: {
      "src": require("../../../assets/main-menu/icon-mobile_close.png"),
      "width": "23",
      "height": "23",
      "alt": "Close"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none u-color--white t-text--sm u-marg-b-xxl"
  }, _vm._l((_vm.nav), function(link) {
    return _c('li', {
      staticClass: "o-list__item u-marg-b-lg u-marg-l-w1of4"
    }, [(link.pageLabel) ? _c('a', {
      staticClass: "c-main-menu__link u-color--white",
      attrs: {
        "href": _vm._getPageURL(link)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm._onChange(_vm._getPageURL(link))
        }
      }
    }, [_c('span', {
      staticClass: "t-text--xl u-uppercase",
      domProps: {
        "innerHTML": _vm._s(link.name)
      }
    })]) : _c('a', {
      staticClass: "c-main-menu__link u-color--white",
      attrs: {
        "href": link.url,
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }
    }, [_c('span', {
      staticClass: "t-text--xl u-uppercase",
      domProps: {
        "innerHTML": _vm._s(link.name)
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518b81e1"}!./src/scripts/components/app-menu-mobile/template.html
// module id = 917
// module chunks = 0